<template>
    <div class="content">
        <div class="container-fluid">
          <div class="row align-items-center mb-1">
            <div class="col-md-6">
              <div class="h2">Advisory Board</div>
            </div>
            <div class="col-md-3 offset-md-3 text-right center">
              <button type="submit" class="btn btn-primary btn-fill" @click="createAdvisoryBoard">Create Advisory Board Member</button>
            </div>
          </div>
            <!--<div class="row align-items-center mb-1">-->
                <!--<div class="col-md-6">-->
                    <!--<div class="h2">Greetings Board</div>-->
                <!--</div>-->
              <!--<div class="col-md-2 offset-md-2 text-right center">-->
                <!--<button type="submit" class="btn btn-primary btn-fill" @click="createGreeting">Create Greeting</button>-->
              <!--</div>-->
              <!--<div class="col-md-2 offset-md-2 text-right center">-->
                    <!--<button type="button" class="btn btn-primary btn-fill" @click="$router.push({ name: 'Greeting Ordering'})">Order Greeting</button>-->
                <!--</div>-->
            <!--</div>-->
            <div class="table-responsive text-center">
                <l-table class="table table-light  table-light table-bordered table-hover"
                         :columns="advBoard.columns" :data="advBoard.data">
                    <template slot="table-row" v-if="advBoard.data.length">
                        <tr v-for="(item, index) in advBoard.data" :key="index" :class="{'inactive': item.status === '0'}">
                            <td>{{item.key}}</td>
                            <td>{{item.value}}</td>
                            <td>
                                <span class="badge badge-success" v-if="item.active != '0'"> Active </span>
                                <span class="badge badge-danger" v-else> Inactive </span>
                            </td>
                            <td>
                                <div class="btn-group" role="group">
                                    <!-- button class="btn btn-secondary btn-sm" @click="viewPodcast(item)" v-tooltip.top-center="advBoard.tooltips.view"><i class="fa fa-eye"></i></button -->
                                    <button class="btn btn-info btn-sm" @click="editAdvisoryBoard(item)" v-tooltip.top-center="advBoard.tooltips.edit"><i class="fa fa-edit"></i></button>
                                </div>
                            </td>
                        </tr>
                    </template>
                </l-table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    const advBoardColumns = ['Member Name', 'Position / Role', 'Status', 'Operations'];
    export default {
        name: 'advBoard',
        components: {
            LTable,
        },
        data() {
            return {
                  advBoard: {
                    tooltips: {
                        view: 'View Advisory Board',
                        edit: 'Edit Advisory Board',
                        delete: 'Inactivate Advisory Board',
                        activate:'Activate Advisory Board',
                    },
                    columns: [...advBoardColumns],
                    tableRowClass: {
                        classname: 'badge-warning',
                        classActiveCondition: 'status'
                    },
                    data: []
                }
            }
        },
        methods: {
            fetchAdvisoryBoard () {
                this.$store.dispatch('GET_ADVISORY_BOARD', 'ADVISORY BOARD')
                    .then((res) => {
                        console.log("@@@@@@ res : ", res);
                        this.advBoard.data = res;
                        console.log("@@@@@@ this.advBoard.data : ", this.advBoard.data);
                    })
                    .catch(err => {
                        console.log("API error : ", err);
                    }),
                    (err) => {
                        console.log("err : ", err);
                    }
                },
                editAdvisoryBoard(advisoryBoard){
                    this.$router.push({name: 'EditAdvisoryBoard', params: {advisoryBoardId: advisoryBoard.groupedKeyValueId}})
                },
                createAdvisoryBoard(){
                    this.$router.push({name: 'CreateAdvisoryBoard'})
                },
        },
        created() {
            this.fetchAdvisoryBoard();
        }
    } // end of export default()
</script>

<style>
    .btn-icon{
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Podcast/AdvisoryBoardList.vue